const width = "57.7%"
const height = "6.4%"
const left = "21.7%"
const isExternal = true
const iniTop = 9.6
const padding = 6.6

const urlgen = name => name.toLocaleLowerCase()
    .replace("&", "")
    .replace(/deepfakes/ig, "deep-fakes")
    .replace(/biometric/ig, "bio-metric")
    .replace(/analyst podcast\:\s/gi, "")
    .replace(/\s|\,|\:/g, "-")

const url = "https://www.securityforum.org/spotlight-on/"
const equalLink = [
    "The impact of the persistent CISO",
    "The race for tech dominance",
    "Organised crime goes digital",
    "Keeping the M&A process secure",
    "Deepfakes and biometric security breakthroughs",
    ["Beyond buzz words: AI, ML and the future of cyber", "https://www.securityforum.org/spotlight-on/beyond-buzz-words-ai--ml-and-the-future-of-cyber/"],
    "Reserving the CISOs seat at the table",
    "Protecting IP in a world of streaming and sharing",
    "The cost of the FUD approach to security",
    "How global law enforcements fight cybercrime",
    "Analyst Podcast: Getting smart about Threats",
    "Analyst Podcast: Roles and rewards: How the role of the CISO is changing",
    "Analyst Podcast: Lessons Learned: How CISOs must change their strategy to survive"
]

const links = [
    ...equalLink.map(label => Array.isArray(label) ? {
        label: label[0],
        href: label[1]
    } : {
        label,
        href: `${url}${urlgen(label)}`
    })
].map((cur, idx) => {
    return {width, height, left, isExternal, top: `${iniTop + (padding * idx)}%`, ...cur, target: "_blank"}
})

links.push({
    label: "ISF Podcast fact sheet 2022",
    href: "https://assets.swoogo.com/uploads/2138821-6350185c87cf6.pdf",
    width: "19.7%",
    height: "4.4%",
    left: "59.7%",
    top: "3.8%",
    target: "_blank"
})

export default links